<script>
    let project = undefined;
    let uploads = []
    import {apiUrl} from '../config.svelte';
    import {onMount,onDestroy} from 'svelte';
    import ProjectSelect from '../Components/ProjectSelect.svelte'
    import DefaultForm from './Forms/DefaultForm.svelte'
    import {Button,Table,Card,CardHeader,CardBody} from 'sveltestrap';
    function loadForms(pr){
        project = pr;
        uploads = []
        fetch(apiUrl+"uploads",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"list",project:project}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            if(x.result){
                uploads = x.data
            }
        })
        .catch((e)=>{

        })

    }

    let history =[];
    function showHist(){
        history=[]
        fetch(apiUrl+"uploads",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"upload-hist",project:project}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            if(x.result){
                history = x.data
            }
        })
        .catch((e)=>{

        })
    }
    function showDetail(result_file_path,hist){
        hist_detail = hist
        hist_detail_output=undefined
        fetch(apiUrl+"uploads",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"upload-result",result_file_path:result_file_path}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            if(x.result){
                hist_detail_output = x.data
            }
        })
        .catch((e)=>{

        })

    }
    let hist_detail=undefined;
    let hist_detail_output=undefined;
</script>


<div>
    <div style="width:500px;float:left"><ProjectSelect  on:change={(e)=>{loadForms(e.detail.value)}}/></div>
    <Button outline color="dark" disabled={!project} on:click={()=>{showHist()}}>История</Button>
</div>
{#if !(history && history.length>0)}
    <div style="margin-top:15px;width:700px;">
        {#each uploads as upl}
            <DefaultForm bind:form={upl} bind:project />
        {/each}
    </div>
{:else}
    <Card style="width:700px;height:calc(100% - 150px)">
        <CardHeader>история внесения {project?project.Project:''} <Button style="float:right" outline color="dark" on:click={()=>{history=[]}} >✖</Button></CardHeader>
        <CardBody style="overflow:auto;">
            <Table size="sm">
                <thead>
                    <th>user</th>
                    <th>date</th>
                    <th>filename</th>
                    <th>result</th>
                    <th>form</th>
                </thead>
                <tbody>
                    {#each history as hist}
                        <tr style="cursor:pointer" on:click={()=>{showDetail(hist.result_file_path,hist)}}>
                            <td>{hist.username}</td>
                            <td>{hist.date_action}</td>
                            <td>{hist.filename}</td>
                            <td>{hist.result}</td>
                            <td>{hist.form_name}</td>
                        </tr>
                        <tr style={hist_detail==hist?"":"display:none"}>
                            <td colspan="5">
                                <Card size="sm">
                                    <CardBody>
                                        <Table>
                                            <tr><td>id</td><td>{hist.id}</td></tr>
                                            <tr><td>project</td><td>{hist.project}</td></tr>
                                            <tr><td>username</td><td>{hist.username}</td></tr>
                                            <tr><td>date</td><td>{hist.date_action}</td></tr>
                                            <tr><td>filename</td><td>{hist.filename}</td></tr>
                                            <tr><td>result</td><td>{hist.result}</td></tr>
                                            <tr><td>output</td><td>{hist_detail_output}</td></tr>
                                            <tr><td>err</td><td>{hist.err}</td></tr>
                                            <tr><td>stack</td><td>{hist.traceback}</td></tr>
                                        </Table>
                                    </CardBody>
                                </Card>
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </Table>
        </CardBody>
    </Card>
{/if}